<template>
    <div class="xml-upload-requests-index">
        <b-notification v-if="error" type="is-danger is-light" aria-close-label="Close notification" role="alert">{{ error }}</b-notification>

        <b-table
            ref="table"
            :data="uploadRequests == null ? [] : uploadRequests"
            bordered
            striped
            narrowed
            hoverable
            :loading="isLoading"
            :opened-detailed="defaultOpenedDetails"
            detailed
            detail-key="id"
            @click="$refs.table.toggleDetails($event)"
            show-detail-icon

            paginated
            backend-pagination
            :total="pagination.total"
            :per-page="pagination.perPage"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            :mobile-cards="false">

            <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
                <router-link :to="{ name: 'XmlUploadRequestShow', params: { id: props.row.id } }">
                    {{ props.row.id }}
                </router-link>
            </b-table-column>

            <b-table-column field="started_at" label="Started at" v-slot="props">
                {{ new Date(props.row.started_at).toLocaleString() }}
            </b-table-column>

            <b-table-column field="finished_at" label="Finished at" v-slot="props">
                <template v-if="props.row.finished_at">
                    {{ new Date(props.row.finished_at).toLocaleString() }}
                </template>
            </b-table-column>

            <b-table-column field="products" label="Products" v-slot="props">
                {{ generateProductList(JSON.parse(props.row.params)) }}
            </b-table-column>

            <b-table-column field="branch_name" label="Branch name" v-slot="props">
                {{ JSON.parse(props.row.params)["branch"] }}
            </b-table-column>

            <b-table-column field="commit" label="Commit ID" v-slot="props">
                {{ JSON.parse(props.row.params)["commit"] }}
            </b-table-column>

            <b-table-column field="ci_service" label="CI service" v-slot="props">
                {{ JSON.parse(props.row.params)["ci_service"] }}
            </b-table-column>

            <b-table-column field="mtr" label="Test set" v-slot="props">
                {{ JSON.parse(props.row.params)["mtr"] }}
            </b-table-column>

            <b-table-column field="result" label="Result" centered v-slot="props">
                <XmlUploadRequestResult :request="props.row"/>
            </b-table-column>

            <b-table-column label="Target build" v-slot="props" centered>
                <b-button
                    v-if="props.row.target_build_id"
                    tag="router-link"
                    type="is-text"
                    size="is-small"
                    :to="{ name: 'TestRunIndex', query: { target_build_ids: [props.row.target_build_id] } }"
                >
                    Open
                </b-button>
            </b-table-column>

            <template #detail="props">
                <vue-json-pretty
                    :data="JSON.parse(props.row.params)">

                    <template #nodeValue="{ node, defaultValue }">
                        <template v-if="typeof node.content === 'string' && node.content.startsWith('https://')">
                            <a :href="node.content" target="_blank">{{ node.content }}</a>
                        </template>
                        <template v-else>{{ defaultValue }}</template>
                    </template>

                </vue-json-pretty>
            </template>

            <template #empty>
                <div class="has-text-centered">No requests</div>
            </template>

        </b-table>
    </div>
</template>

<script>
import api from "@/api/api";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import XmlUploadRequestResult from '@/components/XmlUploadRequestResult';
import _ from "lodash";

export default {
    name: "XmlUploadRequestsIndex",
    components: {
        VueJsonPretty,
        XmlUploadRequestResult,
    },
    data() {
        return {
            isLoading: false,
            error: null,
            uploadRequests: null,
            defaultOpenedDetails: [],
            pagination: {
                perPage: 50,
                total: null,
                page: 1,
            }
        }
    },
    methods: {
        async fetchData() {
            try {
                const response = await api.xmlRequests.fetchAll({
                    page: this.pagination.page,
                    per_page: this.pagination.perPage,
                });
                this.uploadRequests = response.requests;
                this.pagination.total = response.total_count;
            } catch (e) {
                this.error = e;
            }
        },
        onPageChange(page) {
            this.pagination.page = page;
            this.fetchData()
        },
        generateProductList(jsonDict) {
          let product = jsonDict["product"]
          let products_targets = jsonDict["products_targets"]

          if (products_targets === undefined)
            return product

          let products = []
          products_targets = JSON.parse(
              products_targets,
              (product, _target) => { if (!_.isEmpty(product)) products.push(product) }
              )
          products = products.join(", ")

          return products
        }
    },
    async created() {
        this.isLoading = true;
        await this.fetchData();
        this.isLoading = false;
    }
}
</script>

<style lang="scss" scoped>

</style>